// extracted by mini-css-extract-plugin
export default {"social":"social-media_social__pi8I3","no_margin":"social-media_no_margin__RRh5g"};